import React from 'react'
import { withDevice } from '@blazar-plugins/device'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Placement from './AppNexusPlacement'

const mapStateToProps = (state) => ({
  apnReady: state.appNexus.apnReady,
  loggedIn: state.authentication.loggedIn,
  isAdBlockerActive: state.adBlocker.isActive,
})

const Wrapper = styled.div`
  .placement_panorama {
    position: relative;
    padding-top: 16px;
    z-index: 0;
    max-width: 980px;
    margin: auto;
  }
  .top_large_device {
    padding: 16px 0;
  }
  .placement_widescreen-1,
  .placement_widescreen-2,
  .placement_widescreen-3,
  .placement_widescreen-4 {
    margin-bottom: 8px;
    .placement {
      border: solid 1px #dfdede;
      border-radius: 2px;
    }
  }
  .placement_price {
    max-width: 185px;
  }

  .placement_vi_image_integration {
    max-width: 320px;
    max-height: 320px;
  }
`

const PlacementComponent = ({
  apnReady,
  loggedIn,
  isAdBlockerActive,
  inventory,
  id,
  style,
  cogwheel,
  safeframe,
  scaleContent,
  onMediation,
  path,
  device,
  ...props
}) => {
  const inventoryExists = inventory && Object.keys(inventory).length > 0

  if (!isAdBlockerActive && inventoryExists && apnReady) {
    return (
      <Wrapper {...props}>
        <div className={id}>
          <Placement
            inventory={inventory}
            style={style}
            id={id}
            loggedIn={loggedIn}
            cogwheel={cogwheel}
            safeframe={safeframe}
            scaleContent={scaleContent}
            onMediation={onMediation}
            path={path}
            device={device}
          />
        </div>
      </Wrapper>
    )
  }
  return <div style={style} />
}

PlacementComponent.propTypes = {
  apnReady: PropTypes.bool,
  loggedIn: PropTypes.bool.isRequired,
  isAdBlockerActive: PropTypes.bool,
  inventory: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  style: PropTypes.object,
  cogwheel: PropTypes.bool,
  safeframe: PropTypes.bool,
  scaleContent: PropTypes.bool,
  onMediation: PropTypes.func,
  path: PropTypes.string,
  device: PropTypes.object,
}

export default connect(mapStateToProps)(withDevice(PlacementComponent))
